export const categoryOptions = ['Beauty', 'Fashion', 'Home'];
